import { Box, Typography } from "@mui/material";
import type { DateTime } from "luxon";
import { type FC, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { DeleteUpdateDateSelection } from "../../RecurringShift/util/DeleteUpdateDateSelection";
import { getRemovedShiftDates } from "./removedShiftDates";

type Props = {
	initialDate: DateTime;
	originalStartDate: DateTime;
	originalInterval: number;
	chosenDayOffsetFromSunday: number;
	onDateChange: (date: DateTime) => void;
	onValidChange: (isValid: boolean) => void;
};

export const BiweeklyDeleteSection: FC<Props> = ({
	initialDate,
	originalStartDate,
	originalInterval,
	chosenDayOffsetFromSunday,
	onDateChange,
	onValidChange,
}) => {
	const { t } = useTranslation();
	const [selectedDate, setSelectedDate] = useState<DateTime>(initialDate);

	const handleDateChange = (date: DateTime) => {
		setSelectedDate(date);
		onDateChange(date);
	};

	const previewDates = useMemo(() => {
		const dates = getRemovedShiftDates(originalStartDate, originalInterval, selectedDate, chosenDayOffsetFromSunday);
		return dates.map((d) => d.toFormat("ccc LLL d")).join(", ");
	}, [originalStartDate, originalInterval, selectedDate, chosenDayOffsetFromSunday]);

	return (
		<Box sx={{ display: "flex", flexDirection: "column", gap: 1 }} data-testid="biweekly-delete-section">
			<DeleteUpdateDateSelection initialDate={selectedDate} onDateSelectionChange={handleDateChange} mode={"delete"} onValidChange={onValidChange} />
			<Typography variant="body2" sx={{ color: "text.secondary" }}>
				{t("delete.recurring.biweekly.preview", { dates: previewDates })}
			</Typography>
		</Box>
	);
};
